<template>
	<div class="accommodation-input-modal">
		<!-- Modal: Calendar/price overview -->
		<Modal
			:width="100"
			:closeLinkText="$t('priceOverview.close')"
			@close="$emit('close')"
			@update="$emit('update')"
		>
			<div class="accommodation__modal">
				<!-- People selector -->
				<div class="accommodation-input-modal__accordion">
					<Accordion
						v-on:toggle="
							() => {
								this.showPeopleSelect = !this.showPeopleSelect
							}
						"
						:title="'Antal resenärer'"
						:show="this.showPeopleSelect"
						iconType="people"
						:titleParanthesis="totalPeople.toString()"
						:small="true"
					>
						<div class="accommodation-input-modal__people-select">
							<NumberComponent
								:label="$t('search.numberLabelChildren')"
								:underlabel="$t('search.numberLabelChildrenYears')"
								:initalValue="numberOfPersons.amountChildren"
								:disablePlus="
									accommodation.sleepingArrangementBeds <= totalPeople ||
									this.loading
								"
								:disableMinus="this.loading"
								@number-input="
									val => {
										updateNumberOfPersons('children', val)
									}
								"
							/>
							<NumberComponent
								:label="$t('search.numberLabelYouth')"
								:underlabel="$t('search.numberLabelYouthYears')"
								:initalValue="numberOfPersons.amountYouths"
								:disablePlus="
									accommodation.sleepingArrangementBeds <= totalPeople ||
									this.loading
								"
								:disableMinus="this.loading"
								@number-input="
									val => {
										updateNumberOfPersons('youths', val)
									}
								"
							/>
							<NumberComponent
								:label="$t('search.numberLabelAdult')"
								:underlabel="$t('search.numberLabelAdultYears')"
								:initalValue="numberOfPersons.amountAdults"
								:minNumber="1"
								:disablePlus="
									accommodation.sleepingArrangementBeds <= totalPeople ||
									this.loading
								"
								:disableMinus="this.loading"
								@number-input="
									val => {
										updateNumberOfPersons('adults', val)
									}
								"
							/>

							<!-- <Button size="small" color="dark" @click.native="this.showPeopleSelect = false">
								Avbryt
							</Button>
							<Button size="small" @click.native="activeViewTab = 0">
								Uppdatera
							</Button> -->

							<!-- <Loading v-if="this.loading" :dark="true" /> -->
						</div>
					</Accordion>
				</div>

				<!-- Tab links: Seasons -->
				<div v-if="activeViewTab === 1" class="accommodation-input-modal__tabs">
					<Tab
						v-for="(season, index) in priceOverview.seasons"
						:key="season.fromdate"
						:button="true"
						:icon="season.icon"
						hoverEffect="rotate"
						:active="activeSeasonTab === index"
						@click.native="activeSeasonTab = index"
					>
						<span>{{ season.name }}</span>
					</Tab>
				</div>

				<!-- Tab links: Calendar/overview -->
				<Tab
					:inline="true"
					icon="period-view"
					cssClass="accommodation-input-modal__tab-button"
					:active="activeViewTab === 1"
					@click.native="activeViewTab = 1"
				>
					<span>{{ $t('priceOverview.priceOverview') }}</span>
				</Tab>
				<Tab
					:inline="true"
					icon="calendar-view"
					cssClass="accommodation-input-modal__tab-button"
					:active="activeViewTab === 0"
					@click.native="activeViewTab = 0"
				>
					<span>{{ $t('priceOverview.bookPerDay') }}</span>
				</Tab>

				<!-- Loading -->
				<div v-if="loading" class="accommodation-input-modal__loading">
					<Loading :large="true" :dark="true" />
				</div>

				<!-- Tabs content -->
				<div
					v-for="(season, index) in priceOverview.seasons"
					:key="season.fromdate"
					v-show="!loading && activeSeasonTab === index"
					class="accommodation-input-modal__tab"
				>
					<!-- Price overview -->
					<template v-if="activeViewTab === 1">
						<p class="h2 accommodation-input-modal__heading">
							{{ $t('priceOverview.priceOverviewHeading') }}
						</p>

						<!-- Empty state -->
						<div
							v-if="season.seasonPeriods === null"
							class="accommodation-input-modal__empty-season"
						>
							<svg width="59" height="60" viewBox="0 0 59 60" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'infobar__icon'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1444_121460)"><path d="M48 18H1c-.55 0-1-.45-1-1s.45-1 1-1h47c.55 0 1 .45 1 1s-.45 1-1 1zM32 13H17c-.55 0-1-.45-1-1s.45-1 1-1h15c.55 0 1 .45 1 1s-.45 1-1 1zM23 27.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM33 27.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM43 27.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM13 35.5H7c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM23 35.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM33 35.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM13 43.5H7c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM23 43.5h-6c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5zm-5.5-1h5v-3h-5v3zM10 13c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1zM40 13c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1z" fill="#2A3E61"/><path d="M55.79 56.76A10.97 10.97 0 0059 49c0-6.07-4.93-11-11-11-3.02 0-5.77 1.23-7.76 3.21 0 0-.02 0-.02.01s0 .02-.01.02A10.97 10.97 0 0037 49c0 6.07 4.93 11 11 11 3.02 0 5.77-1.23 7.76-3.21 0 0 .02 0 .02-.01s0-.02.01-.02zM57 49c0 2.12-.74 4.07-1.98 5.61L42.38 41.97a8.971 8.971 0 015.61-1.98c4.96 0 9 4.04 9 9L57 49zm-18 0c0-2.12.74-4.07 1.98-5.61l12.64 12.64a8.971 8.971 0 01-5.61 1.98c-4.96 0-9-4.04-9-9L39 49z" fill="#E15B5B"/><path d="M33.05 48.01S33.02 48 33 48H5c-1.65 0-3-1.35-3-3V11c0-1.65 1.35-3 3-3h2V6H5c-2.76 0-5 2.24-5 5v34c0 2.76 2.24 5 5 5h28s.03 0 .05-.01c-.02-.33-.05-.66-.05-.99 0-.33.03-.66.05-.99zM37 6H13v2h24V6zM44 6h-1v2h1c1.65 0 3 1.35 3 3v23s0 .03.01.05c.33-.02.66-.05.99-.05.33 0 .66.03.99.05 0-.02.01-.03.01-.05V11c0-2.76-2.24-5-5-5z" fill="#2A3E61"/></g><defs><clipPath id="clip0_1444_121460"><path fill="#fff" d="M0 0h59v60H0z"/></clipPath></defs></svg>
							<p class="accommodation-input-modal__empty-season__heading">
								{{ $t('priceOverview.emptySeasonMessage') }}
							</p>
							<p class="accommodation-input-modal__empty-season__text">
								{{ $t('priceOverview.youCanTryTo') }}
								<LinkButton @click.native="activeViewTab = 0">
									{{ $t('priceOverview.searchForInduvidualDates') }}
								</LinkButton>
								{{ $t('priceOverview.orLookInAnotherSeason') }}
							</p>
							<Button size="small" @click.native="activeViewTab = 0">
								{{ $t('priceOverview.calendarCTA') }}
							</Button>
							<template v-for="(season, index) in priceOverview.seasons">
								<Button
									v-if="activeSeasonTab != index"
									:key="season.fromdate"
									size="small"
									color="dark"
									@click.native="activeSeasonTab = index"
								>
									{{ season.name }}
								</Button>
							</template>
						</div>

						<template v-else>
							<PriceOverview
								:season="season"
								:startDate="startDate"
								:endDate="endDate"
								@calendar-view="activeViewTab = 0"
								@period-selected="periodSelect"
							/>
							<!-- :selectedStartDate="selectedPeriod.fromdate"
								:selectedEndDate="selectedPeriod.todate" -->
						</template>
					</template>

					<!-- Calendar -->
					<template v-else>
						<p class="h2 accommodation-input-modal__heading">
							{{ $t('priceOverview.calendarHeading') }}
						</p>
						<DatePicker
							class="accommodation-input-modal__calendar"
							:selectForward="false"
							:format="'YYYY-MM-DD'"
							:allowedDates="allowedDates"
							:minNight="minNight"
							:maxNight="maxNight"
							:maxDate="maxDate"
							:startDate="startDate"
							:endDate="endDate"
							:monthList="$t('datepicker.monthList')"
							:placeholder="$t('datepicker.selectDateRange')"
							:startdateHelptext="$t('datepicker.selectArrivalDate')"
							:enddateHelptext="$t('datepicker.selectDepartureDate')"
							:wideTheme="true"
							@update="update"
							@reset="reset"
						/>
						<div class="datepicker-alert">
							<AlertMessage :show="false" :blue="true" :fat="true">
								{{ $t('search.datepickerAlertText') }}
							</AlertMessage>
						</div>

						<InputComponent
							v-model="campaignCode.value"
							class="accommodation-input-modal__campaigncode"
							:placeholderValue="$t('search.placeholderAddCampaigncode')"
							:hasError="campaignCode.error"
							:errorMessage="campaignCode.message"
							:lightTheme="true"
							:accepted="campaignCode.accepted"
						/>

						<div class="accommodation-input-modal__buttons">
							<Button
								@click.native="confirmDates()"
								:loading="loadingToConfirm"
								:disabled="validateDateAndPeaple()"
							>
								{{ $t('priceOverview.selectPeriod') }}
							</Button>
							<Button
								@click.native="$emit('close')"
								:disabled="loadingToConfirm"
								color="primary4"
							>
								{{ $t('priceOverview.cancel') }}
							</Button>
						</div>
					</template>
				</div>

				<!-- Tab links: Seasons -->
				<div
					v-if="!loading && activeViewTab === 1"
					class="accommodation-input-modal__tabs"
				>
					<Tab
						v-for="(season, index) in priceOverview.seasons"
						:key="season.fromdate"
						:button="true"
						:icon="season.icon"
						hoverEffect="rotate"
						:active="activeSeasonTab === index"
						@click.native="activeSeasonTab = index"
					>
						<span>{{ season.name }}</span>
					</Tab>
				</div>
			</div>
		</Modal>

		<Modal v-show="showConfirmationModal" @close="closeConfirmationModal()">
			<div class="confirm-period-modal">
				<h4 class="confirm-period-modal__title">
					<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2H2a1 1 0 00-1 1v18a1 1 0 001 1h20a1 1 0 001-1V3a1 1 0 00-1-1zM6.75 20H3v-3h3.75zm0-4H3v-3h3.75zm0-4H3V9h3.75zm4.75 8H7.75v-3h3.75zm0-4H7.75v-3h3.75zm0-4H7.75V9h3.75zm4.75 8H12.5v-3h3.75zm0-4H12.5v-3h3.75zm0-4H12.5V9h3.75zM21 20h-3.75v-3H21zm0-4h-3.75v-3H21zm0-4h-3.75V9H21zm0-5H3V4h18z"/></svg>
					<span>{{ $t('priceOverview.changePeriod') }}</span>
				</h4>
				<p class="confirm-period-modal__text">
					<span>{{ selectedPeriod.dates }}</span>
					{{ selectedPeriod.label }} ({{
						selectedPeriod.startdayname + '-' + selectedPeriod.enddayname
					}})
				</p>

				<!-- Campaign code -->
				<div class="confirm-period-modal__campaigncode">
					<LinkButton
						class="confirm-period-modal__campaigncode-toggle"
						:disabled="false"
						:icon="showCampainCodeInput ? 'cross' : 'plus'"
						alignment="left"
						@click.native="showCampainCodeInput = !showCampainCodeInput"
					>
						{{ $t('priceOverview.addCampaignCode') }}
					</LinkButton>
					<InputComponent
						v-if="showCampainCodeInput"
						v-model="campaignCode.value"
						class="confirm-period-modal__campaigncode-input"
						:placeholderValue="$t('search.placeholderAddCampaigncode')"
						:hasError="campaignCode.error"
						:errorMessage="campaignCode.message"
						:lightTheme="true"
						:accepted="campaignCode.accepted"
					>
						<!-- :isDisabled="campaignCode.disabled || loading" -->

						<!-- <Button
							@click.native="validateCampainCode"
							class="campaign__button btn--button-like-behavior"
							size="small"
						>
							<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
						</Button> -->
					</InputComponent>
				</div>

				<div class="confirm-period-modal__buttons">
					<Button @click.native="confirmPeriod()" :loading="loadingToConfirm">
						{{ $t('priceOverview.confirmPeriod') }}
					</Button>
					<Button
						color="primary4"
						:disabled="loadingToConfirm"
						@click.native="closeConfirmationModal()"
					>
						{{ $t('priceOverview.cancel') }}
					</Button>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
//import mixin from '../mixin'
//import moment from 'moment'

import PriceOverview from '../molecules/PriceOverview'
import NumberComponent from '../atoms/NumberComponent.vue'
import InputComponent from '../atoms/InputComponent.vue'
import Tab from '../atoms/Tab.vue'
import Modal from '../molecules/Modal.vue'
import DatePicker from '../molecules/DatePicker'
import AlertMessage from '../atoms/AlertMessage'
import Button from '../atoms/Button'
import LinkButton from '../atoms/LinkButton'
import Loading from '../atoms/Loading'
import Accordion from '../molecules/Accordion'

export default {
	name: 'AccommodationInputModal',
	store,
	components: {
		NumberComponent,
		InputComponent,
		Modal,
		PriceOverview,
		Tab,
		DatePicker,
		AlertMessage,
		Button,
		LinkButton,
		Loading,
		Accordion
	},
	props: {
		accommodation: {
			type: Object,
			default: () => {}
		},
		totalPeople: {
			type: Number,
			default: 0
		},
		numberOfPersons: {
			type: Object,
			default: () => {}
		},
		startDate: {
			type: [String, Date],
			default: undefined
		},
		endDate: {
			type: [String, Date],
			default: undefined
		},
		maxDate: {
			type: [String, Date, Boolean],
			default: false
		},
		minNight: {
			type: Number,
			default: undefined
		},
		maxNight: {
			type: Number,
			default: undefined
		},
		selectForward: {
			type: Boolean,
			default: true
		},
		allowedDates: {
			type: Array,
			default: () => []
		},
		close: {
			type: Function,
			default: () => window.console.log('stänge')
		},
		campaignCode: {
			type: Object,
			default: () => {}
		},
		loadingToConfirm: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showPeopleSelect: false,
			activeSeasonTab: 1,
			activeViewTab: 1,
			priceOverview: {},
			showConfirmationModal: false,
			loading: true,
			selectedPeriod: {
				dates: '',
				fromdate: '',
				todate: '',
				label: '',
				startdayname: '',
				enddayname: ''
			},
			showCampainCodeInput: false
			// campaignCode: {
			// 	value: '',
			// 	message: '',
			// 	show: false,
			// 	error: false,
			// 	accepted: false
			// }
		}
	},
	methods: {
		onChange() {
			//do something
		},
		validateDateAndPeaple() {
			return !(
				this.startDate &&
				this.endDate &&
				this.numberOfPersons.amountAdults > 0
			)
		},
		getPriceOverview() {
			this.loading = true

			const mapParams = {
				poollid: this.$route.params.id.split('_')[1],
				unitlid: this.$route.params.id.split('_')[2],
				children: this.numberOfPersons.amountChildren,
				youths: this.numberOfPersons.amountYouths,
				adults: this.numberOfPersons.amountAdults
			}

			store
				.dispatch('GET_ACCOMMODATION_PRICEOVERVIEW', { ...mapParams })
				.then(success => {
					if (success) {
						this.priceOverview = success
						//store.dispatch('GTM_PUSH_ACCOMMODATION_DETAILS', success)
					}
					this.loading = false
				})
		},
		periodSelect(
			id,
			value,
			startdayname,
			enddayname,
			length,
			fromdate,
			todate
		) {
			this.selectedPeriod = {
				dates: value,
				fromdate: fromdate,
				todate: todate,
				label:
					length < 6
						? this.$t('priceOverview.shortWeek')
						: this.$t('priceOverview.week'),
				startdayname: startdayname,
				enddayname: enddayname
			}
			const newDates = {
				start: fromdate,
				end: todate
			}
			this.$emit('update', newDates)
			this.showConfirmationModal = true
		},
		closeConfirmationModal() {
			this.showConfirmationModal = false
			this.showCampainCodeInput = false
			this.selectedPeriod = {
				dates: '',
				fromdate: '',
				todate: '',
				label: '',
				startdayname: '',
				enddayname: ''
			}
			// this.startDate = ''
			// this.endDate = ''
			// this.$emit('clearSelectedDates')
			this.$emit('reset')
		},
		confirmPeriod() {
			const newDates = {
				start: this.selectedPeriod.fromdate,
				end: this.selectedPeriod.todate,
				campaignCode: this.campaignCode.value
			}

			this.$emit('confirm', newDates)
		},
		confirmDates() {
			const newDates = {
				start: this.startDate,
				end: this.endDate,
				campaignCode: this.campaignCode.value
			}

			this.$emit('confirm', newDates)
		},
		update(data) {
			this.$emit('update', data)
		},
		reset() {
			this.$emit('reset')
		},
		updateNumberOfPersons(type, val) {
			if (type === 'adults') {
				this.numberOfPersons.amountAdults = val
			}
			if (type === 'youths') {
				this.numberOfPersons.amountYouths = val
			}
			if (type === 'children') {
				this.numberOfPersons.amountChildren = val
			}
			this.getPriceOverview()
		}
	},
	created: function () {
		const params = ''
		this.getPriceOverview(params)
	}
}
</script>

<style scoped lang="scss">
.accommodation-input-modal {
	.accordion {
		margin-right: 90px;
		margin-bottom: 20px;
	}

	&__loading {
		margin: 0 0 40px 0;
	}

	&__people-select {
		display: flex;
		flex-flow: row wrap;

		> div {
			flex-grow: calc(100% / 4 - 20px);
			margin: 0px 20px 20px 0px;
		}

		button {
			margin: auto 10px 25px 0px;

			&:last-child {
				margin-right: 0;
			}
		}
	}

	&__tabs {
		margin: 20px 0;

		.tab--button {
			padding: 12px 20px 12px 15px;
			display: block;
			height: auto;
			border: 1px solid $colorPrimary7;
			border-radius: 3px;
			font-weight: 400;
			font-size: 18px;
			line-height: 1;
			color: $colorBlack;
			margin: 0 0 10px 0;

			span {
				display: inline-block;
				vertical-align: middle;
				margin-left: 10px;
			}

			&:hover {
				background: #e4f8fe;
				border: 1px solid $colorPrimary;
				// padding: 11px 19px 11px 14px;
				// margin-bottom: 8px;
			}

			&.tab--active,
			&.tab--active:hover {
				background: $colorPrimary;
				color: $colorWhite;
				font-weight: 600;
				padding: 12px 20px 12px 15px;
				border: 1px solid $colorPrimary7;
			}
		}
	}

	&__tab {
		margin: 0 0 30px 0;
	}

	&__heading {
		margin-bottom: 10px;
	}
	&__calendar {
		margin-top: 30px;
	}

	&__campaigncode {
		max-width: 468px;
		margin-top: 20px;
	}

	&__buttons {
		margin: 40px 0 0 0;

		button {
			margin-right: 10px;
			vertical-align: bottom;
		}
	}

	&__empty-season {
		background: #f4f5f7;
		border: 1px solid #d4d8df;
		border-radius: 3px;
		padding: 45px 40px 60px;
		margin: 30px 0 40px 0;
		text-align: center;

		svg {
			margin-bottom: 22px;
		}

		button {
			margin-right: 10px;
		}

		&__heading {
			font-size: 22px;
			line-height: 30px;
			font-weight: 500;
			margin-bottom: 20px;
		}
		&__text {
			font-size: 14px;
			line-height: 18px;
			margin-bottom: 60px;
			button {
				margin: 0;
				padding: 0;
			}
		}
	}

	.confirm-period-modal {
		&__title {
			font-size: 16px;
			line-height: 24px;

			svg {
				display: inline-block;
				width: 24px;
				height: 24px;
				fill: $colorPrimary;
				vertical-align: middle;
				margin-right: 10px;
			}
		}

		&__text {
			border-left: 3px solid $colorGreen;
			padding-left: 18px;
			font-size: 14px;
			margin: 20px 0;

			span {
				display: block;
				font-size: 18px;
				font-weight: 600;
			}
		}

		&__campaigncode-toggle {
		}

		&__campaigncode-input {
			margin-top: 10px;
		}

		&__buttons {
			margin: 40px 0 0 0;

			button {
				margin: 0 10px 0 0;
				vertical-align: bottom;
			}
		}
	}

	@media only screen and (min-width: 64em) {
		&__tabs {
			// margin: -10px 0 0 0;

			.tab--button {
				display: inline-block;
				margin: 0 20px 15px 0;
			}
		}
	}
}
</style>
